import * as React from 'react';

import { TransportAccessibility } from '../../../components/TransportAccessibilityRate';
import { MAX_TRANSPORT_ACCESSIBILITY_RATE } from '../../../constants/transportAccessibility';
import { ITransportAccessibility } from '../../../types/newbuilding/transportAccessibility';
import { prepareRate, prepareTransportAccessibility } from '../helpers';

export interface ITransportAccessibilityContainerProps {
  accessibility: ITransportAccessibility;
}

export const TransportAccessibilityContainer: React.VFC<ITransportAccessibilityContainerProps> = ({
  accessibility,
}) => {
  const { description, iconUrl, rate, rateDetails, title } = accessibility;

  const displayRate = prepareRate(rate);
  const displayMaxRate = String(MAX_TRANSPORT_ACCESSIBILITY_RATE);
  const displayTerms = React.useMemo(() => prepareTransportAccessibility(rateDetails), [rateDetails]);

  return (
    <TransportAccessibility
      description={description}
      iconUrl={iconUrl}
      maxRate={displayMaxRate}
      rate={displayRate}
      title={title}
      terms={displayTerms}
    />
  );
};
